const timetabledata = {
  Monday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Dhikr" },
      { time: "5:30 – 5:45", activity: "Light breakfast" },
      { time: "5:45 – 6:00", activity: "Cloth organizing" },
      { time: "6:00 – 6:30", activity: "Just Chilling and Gaming" },
      { time: "6:30 – 7:00", activity: "Fam Time" },
      { time: "7:00 – 7:30", activity: "Bathing and Refreshing" },
      { time: "7:30 – 8:00", activity: "Breakfast break" },
      {
        time: "8:00 – 9:00",
        activity: "Job Browsing and Vision Updation",
      },
      { time: "9:00 – 12:45", activity: "Coding Time" },
      { time: "1:00 – 1:20", activity: "Dhuhr prayer" },
      { time: "1:30 – 2:30", activity: "Lunch + Short rest" },
      { time: "2:30 – 4:00", activity: "Learning time (courses/docs)" },
      { time: "4:00 – 4:30", activity: "Asr Prayer" },
      { time: "4:30 – 6:00", activity: "Break or Friends Time" },
      { time: "6:30 – 6:50", activity: "Maghrib prayer" },
      { time: "7:00 – 7:30", activity: "Quran Recitiation" },
      { time: "7:30 – 8:00", activity: "Bathing and Refreshment" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + chill + code " },
      { time: "10:00 – 10:30", activity: "Wind down (journal/dua)" },
    ],
    dua: "اللَّهُمَّ زِدْنِي عِلْمًا نَافِعًا، وَرِزْقًا طَيِّبًا، وَعَمَلًا مُتَقَبَّلًا",
    meaning:
      "O Allah, increase me in beneficial knowledge, good provision, and accepted deeds",
  },
  Tuesday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Dhikr" },
      { time: "5:30 – 6:00", activity: "Quran Time" },
      { time: "6:00 – 6:30", activity: "Chill Time and Gaming" },
      { time: "6:30 – 7:00", activity: "Fam Time" },
      { time: "7:00 – 7:30", activity: "Bathing and Refreshing" },
      { time: "7:30 – 8:00", activity: "Break Fast Time" },
      { time: "8:00 – 9:00", activity: "Job Browsing and Vision Updation" },
      { time: "9:00 – 10:00", activity: "Youtube Time" },
      {
        time: "10:00 – 12:00",
        activity: "Work on Fullstack (Backend API + Frontend)",
      },
      { time: "12:00 – 1:00", activity: "Learn new frontend tricks" },
      { time: "1:00 – 1:20", activity: "Dhuhr prayer" },
      { time: "1:30 – 2:30", activity: "Lunch + Short nap" },
      { time: "2:30 – 4:00", activity: "Interview prep + mock questions" },
      { time: "4:00 – 4:30", activity: "Asr prayer" },
      { time: "4:30 – 6:00", activity: "Chill time Movies/Friedns time" },
      { time: "6:30 – 7:00", activity: "Maghrib prayer" },
      { time: "7:00 – 7:30", activity: "Quram Time" },
      { time: "7:30 – 8:00", activity: "Bathing and Refreshment" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + Yt" },
      {
        time: "10:00 – 10:30",
        activity: "Gratitude journaling + plan next day",
      },
    ],
    dua: "حَسْبِيَ اللَّهُ لَا إِلَـٰهَ إِلَّا هُوَ، عَلَيْهِ تَوَكَّلْتُ وَهُوَ رَبُّ الْعَرْشِ الْعَظِيمِ",
    meaning:
      "Allah is sufficient for me. There is no deity except Him. I have placed my trust in Him, and He is the Lord of the Mighty Throne",
  },
  Wednesday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Dhikr" },
      { time: "5:30 – 6:00", activity: "Light breakfast" },
      { time: "6:00 – 6:30", activity: "Bathing / Freshen up" },
      { time: "6:30 – 9:00", activity: "Fix bugs in current repo" },
      { time: "9:00 – 9:30", activity: "Tea + Break" },
      {
        time: "9:30 – 11:00",
        activity: "Fullstack coding (Integrate front-end with back-end)",
      },
      { time: "11:00 – 12:30", activity: "Apply for 2 jobs" },
      { time: "1:00 – 1:20", activity: "Dhuhr prayer" },
      { time: "1:30 – 2:30", activity: "Lunch + Rest" },
      { time: "2:30 – 4:30", activity: "Read job interview tips + mock tests" },
      { time: "4:30 – 4:50", activity: "Asr prayer" },
      { time: "5:00 – 6:00", activity: "Project documentation" },
      { time: "6:30 – 6:50", activity: "Maghrib prayer" },
      { time: "7:00 – 8:00", activity: "Personal reading / reflection" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + Quran + Duas" },
    ],
    dua: "رَبِّ اشْرَحْ لِي صَدْرِي، وَيَسِّرْ لِي أَمْرِي",
    meaning: "O my Lord, expand for me my chest and make my task easy for me.",
  },
  Thursday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Dhikr" },
      { time: "5:30 – 6:00", activity: "Light breakfast" },
      { time: "6:00 – 6:30", activity: "Bathing / Freshen up" },
      { time: "6:30 – 9:00", activity: "Design portfolio layout improvements" },
      { time: "9:00 – 9:30", activity: "Job portal browsing" },
      { time: "9:30 – 10:00", activity: "Tea / snack break" },
      { time: "10:00 – 12:00", activity: "Apply to startup jobs" },
      { time: "12:00 – 1:00", activity: "Research new tech (e.g. AI / APIs)" },
      { time: "1:00 – 1:20", activity: "Dhuhr prayer" },
      { time: "1:30 – 2:30", activity: "Lunch + Relaxation" },
      {
        time: "2:30 – 4:00",
        activity: "Record mock interview / review performance",
      },
      { time: "4:00 – 4:30", activity: "Asr prayer" },
      { time: "4:30 – 6:00", activity: "Resume polishing + feedback check" },
      { time: "6:30 – 6:50", activity: "Maghrib prayer" },
      { time: "7:00 – 8:00", activity: "Dev podcast / chill scroll" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + Reflection" },
    ],
    dua: "اللَّهُمَّ إِنِّي أَسْأَلُكَ الْعَفْوَ وَالْعَافِيَةَ",
    meaning: "O Allah, I ask You for pardon and well-being.",
  },
  Friday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Dhikr" },
      { time: "5:30 – 6:00", activity: "Light breakfast" },
      { time: "6:00 – 6:30", activity: "Bathing / Freshen up" },
      { time: "6:30 – 9:00", activity: "Light portfolio tweaks" },
      { time: "9:00 – 10:00", activity: "Read Surah Kahf" },
      { time: "10:00 – 12:00", activity: "Prepare for Jummah + chill" },
      { time: "12:30 – 2:00", activity: "Jummah + Lunch + Nap" },
      {
        time: "2:00 – 4:00",
        activity: "Deep learning session (backend/devops)",
      },
      { time: "4:00 – 4:30", activity: "Asr prayer" },
      { time: "4:30 – 6:00", activity: "Follow-up on job applications" },
      { time: "6:30 – 6:50", activity: "Maghrib prayer" },
      { time: "7:00 – 8:00", activity: "Family talk / walk" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + Quran + Relax" },
    ],
    dua: "اللَّهُمَّ إِنِّي أَسْأَلُكَ مِنْ فَضْلِكَ الْعَظِيمِ",
    meaning: "O Allah, I ask You from Your great bounty",
  },
  Saturday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Quran" },
      { time: "5:30 – 6:30", activity: "Tea + Chill coding" },
      { time: "6:30 – 7:00", activity: "Bathing / Freshen up" },
      { time: "7:00 – 9:00", activity: "Learn new tech stack hands-on" },
      { time: "9:00 – 10:00", activity: "Breakfast + Job alerts check" },
      { time: "10:00 – 12:00", activity: "Side project UI" },
      { time: "12:00 – 1:00", activity: "Chill or Quran session" },
      { time: "1:00 – 1:20", activity: "Dhuhr prayer" },
      { time: "1:30 – 2:30", activity: "Lunch + Rest" },
      {
        time: "2:30 – 4:30",
        activity: "Read blog articles / watch dev interviews",
      },
      { time: "4:30 – 4:50", activity: "Asr prayer" },
      { time: "5:00 – 6:00", activity: "Practice mock coding interviews" },
      { time: "6:30 – 6:50", activity: "Maghrib prayer" },
      { time: "7:00 – 8:00", activity: "Relax + family talk" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + Reflection" },
    ],
    dua: "يَا حَيُّ يَا قَيُّومُ، بِرَحْمَتِكَ أَسْتَغِيثُ",
    meaning: "O Ever-Living, O Sustainer, in Your mercy I seek relief.",
  },
  Sunday: {
    schedule: [
      { time: "5:00 – 5:30", activity: "Fajr + Dhikr" },
      { time: "5:30 – 6:00", activity: "Light breakfast" },
      { time: "6:00 – 6:30", activity: "Bathing / Freshen up" },
      { time: "6:30 – 9:00", activity: "Deep learning (new JS framework)" },
      { time: "9:00 – 10:00", activity: "Job portal update" },
      { time: "10:00 – 12:00", activity: "Codebase cleanup" },
      { time: "12:00 – 1:00", activity: "Relax or study Quran" },
      { time: "1:00 – 1:20", activity: "Dhuhr prayer" },
      { time: "1:30 – 2:30", activity: "Lunch + Rest" },
      { time: "2:30 – 4:00", activity: "Study side project ideas" },
      { time: "4:00 – 4:30", activity: "Asr prayer" },
      { time: "5:00 – 6:00", activity: "Follow-up on job applications" },
      { time: "6:30 – 6:50", activity: "Maghrib prayer" },
      { time: "7:00 – 8:00", activity: "Family time" },
      { time: "8:00 – 8:20", activity: "Isha prayer" },
      { time: "8:30 – 10:00", activity: "Dinner + Plan upcoming week" },
    ],
    dua: "رَبِّ إِنِّي لِمَا أَنْزَلْتَ إِلَيَّ مِنْ خَيْرٍ فَقِيرٌ",
    meaning:
      "My Lord, indeed I am in need of whatever good You send down to me",
  },
};

export default timetabledata;
